import React, { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useHistory } from "react-router-dom";

// importing all the themes
import Hometheme from "../themes/home-theme";
import Signintheme from "themes/signin-theme";
import Signuptheme from "themes/signup-theme";
import OtpVerifytheme from "themes/otp-verify-theme";

import KYCtheme from "themes/kYC-theme";

import Maintheme from "themes/main-theme";
import Homepage from "Pages/Home";
import Buytheme from "themes/buy-theme";
import Buytrasadetails from "themes/buytrasadetails-theme";
import Selltheme from "themes/sell-theme";
import Sellcrypto from "themes/sellcrypto-theme";
import Sellordertheme from "themes/sellorder-theme";
// import Transactiontheme from "themes/transaction-theme";
import Verifyemailtheme from "themes/verifyemailtheme";
import Personaldetailtheme from "themes/personaldetail-theme";
import Sellkyctheme from "themes/sellkyc-theme";
import Defiswaptheme from "themes/defiswap-theme";
import Deficonnecttheme from "themes/deficonnect-theme";
import Hisotrytheme from "themes/hisotry-theme";
import Settingtheme from "themes/setting-theme";
import { PrivateRoute } from "Component/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import SmoothScroll from "Component/Common/Scroll-to-top";
import ProfileTheme from "themes/profile-theme";
import Invite from "Pages/Invite/Invite";
import WithdrawTheme from "themes/withdraw-history-theme";
import Notfound from "Pages/Notfound";
import PortfolioTheme from "themes/portfolio-theme";
import GraphTheme from "themes/graph-theme";
import BlogsTheme from "themes/blogs-theme";
import ViewBlogsTheme from "themes/view-blogs-theme";
import FavouritesTheme from "themes/favourtie-theme";

import TransactionHistory from "themes/hisotry-theme";
import Uniramp from "themes/uniramp-theme";
import { useLocation } from 'react-router-dom';
import * as ROUTES from 'helpers/route-helper';


import ResetPasswordtheme from "themes/resetPasswordtheme";
import Contenttheme from "themes/contenttheme";
import { useTranslation } from 'react-i18next';

const AuthPages = ({ token, children }) => {
  if (token) {
    return <Navigate to={"/"} />;
  }
  return children;
};

const MyRouts = () => {
  const { user } = useSelector(({ Login }) => Login);
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const lang = localStorage.getItem("lang");

  useEffect(() => {

    setTimeout(()=>{
      const pathName = location.pathname.substring(1);
      document.title = pathName ? `${t(pathName)} | ${t('soorx')}` : `${t('soorx')}`;

    },500)
  }, [location.pathname.substring(1)]);

 /**
     * Used for defining the page urls for public of private routes
  */
  return (
    <div>
      <SmoothScroll>
        <Routes>
          <Route path={ROUTES.SIGN_IN} element={<AuthPages token={user?.Token}><Signintheme /></AuthPages>} />
          <Route path={ROUTES.SLUG} element={<Contenttheme />} />
          <Route path={ROUTES.VERIFY_EMAIL} element={<AuthPages token={user?.Token}><Verifyemailtheme /> </AuthPages>} />
          <Route path={ROUTES.RESET_PASSWORD} element={<AuthPages token={user?.Token}><ResetPasswordtheme /> </AuthPages>} />
          <Route path={ROUTES.OTP_VERIFICATION} element={<AuthPages token={user?.Token}> <OtpVerifytheme /> </AuthPages>} />
          <Route path={ROUTES.SIGN_UP} element={<AuthPages token={user?.Token}> <Signuptheme /></AuthPages>} />
          <Route path={ROUTES.INVITE} element={<Invite />} />
          <Route path="*"  element={<Notfound />} />

          <Route path="/" element={<Hometheme />}>
            <Route index element={<Homepage />} />
            <Route path={ROUTES.BUY} element={<PrivateRoute> <Buytheme key="Buy" /> </PrivateRoute>} />
            <Route path={ROUTES.BUY_DETAILS} element={<PrivateRoute> <Buytrasadetails /> </PrivateRoute>} />
            <Route path={ROUTES.PROFILE} element={<PrivateRoute> <ProfileTheme /> </PrivateRoute>} />
            <Route path={ROUTES.UNIRAMP} element={<PrivateRoute> <Uniramp /> </PrivateRoute>} />
            <Route path={ROUTES.WITHDRAW_HISTORY} element={<PrivateRoute><WithdrawTheme /> </PrivateRoute>} />
            <Route path={ROUTES.BUY_SELL_HISTORY} element={<PrivateRoute><TransactionHistory /></PrivateRoute>} />
            <Route path={ROUTES.KYC} element={<PrivateRoute><KYCtheme /> </PrivateRoute>} />
            <Route path={ROUTES.SELL_CRYPTO} element={<PrivateRoute> <Selltheme key="Sell" /> </PrivateRoute>} />
            <Route path={ROUTES.SELL_ORDER} element={<PrivateRoute> <Sellordertheme /> </PrivateRoute>} />
            <Route path={ROUTES.PERSONAL_DETAILS} element={<PrivateRoute><Personaldetailtheme /> </PrivateRoute>} />
            <Route path={ROUTES.SELL_KYC} element={<PrivateRoute><Sellkyctheme /> </PrivateRoute>} />
            <Route path={ROUTES.WALLET_CONNECT} element={<PrivateRoute> <Deficonnecttheme /> </PrivateRoute>} />
            <Route path={ROUTES.HISTORY} element={<PrivateRoute> <Hisotrytheme /> </PrivateRoute>} />
            <Route path={ROUTES.SETTINGS} element={<PrivateRoute>  <Settingtheme /></PrivateRoute>} />
            <Route path={ROUTES.PORTFOLIO} element={<PrivateRoute>  <PortfolioTheme /></PrivateRoute>} />
            <Route path={ROUTES.GRAPH} element={<PrivateRoute>  <GraphTheme /></PrivateRoute>} />
            <Route path={ROUTES.BLOGS} element={<PrivateRoute>  <BlogsTheme /></PrivateRoute>} />
            <Route path={ROUTES.VIEW_BLOGS} element={<PrivateRoute>  <ViewBlogsTheme /></PrivateRoute>} />
            <Route path={ROUTES.FAVOURITES} element={<PrivateRoute>  <FavouritesTheme /></PrivateRoute>} />

            

          </Route>
        </Routes>
      </SmoothScroll>
    </div>
  );
};
export default MyRouts;
